var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rest"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 3.41325C3.72667 3.41325 3.5 3.18658 3.5 2.91325V1.74658C3.5 1.47325 3.72667 1.24658 4 1.24658C4.27333 1.24658 4.5 1.47325 4.5 1.74658V2.91325C4.5 3.19325 4.27333 3.41325 4 3.41325Z",
    fill: "#FF6A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.6665 3.41325C6.39317 3.41325 6.1665 3.18658 6.1665 2.91325V1.74658C6.1665 1.47325 6.39317 1.24658 6.6665 1.24658C6.93984 1.24658 7.1665 1.47325 7.1665 1.74658V2.91325C7.1665 3.19325 6.93984 3.41325 6.6665 3.41325Z",
    fill: "#FF6A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.3335 3.41325C9.06016 3.41325 8.8335 3.18658 8.8335 2.91325V1.74658C8.8335 1.47325 9.06016 1.24658 9.3335 1.24658C9.60683 1.24658 9.8335 1.47325 9.8335 1.74658V2.91325C9.8335 3.19325 9.60683 3.41325 9.3335 3.41325Z",
    fill: "#FF6A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.8332 8.83334C14.8332 7.08667 13.4798 5.67334 11.7732 5.52667C11.2798 4.72001 10.3998 4.17334 9.3865 4.17334H4.47317C2.9265 4.17334 1.6665 5.43334 1.6665 6.98001V7.33334H12.1932V6.98001C12.1932 6.85334 12.1732 6.72667 12.1532 6.60667C13.1198 6.89334 13.8332 7.77334 13.8332 8.83334C13.8332 9.88001 13.1398 10.7533 12.1932 11.0467V8.00001H1.6665V11.86C1.6665 13.4067 2.9265 14.6667 4.47317 14.6667H9.3865C10.8532 14.6667 12.0465 13.5333 12.1665 12.0933C13.6865 11.7867 14.8332 10.44 14.8332 8.83334Z",
    fill: "#FF6A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResting);
export default __webpack_public_path__ + "static/media/resting.37975caf06dd59d01a2f849413b91d4b.svg";
export { ForwardRef as ReactComponent };